module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_16_9_w_2156.6398d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_2156.jpg
// module id = zE+R
// module chunks = 0